import React, { useState } from 'react'
import useMediaQuery from '../../../hooks/useMediaQuery'
import { StaticImage } from 'gatsby-plugin-image'
export default function VBot() {
  const isMobile = useMediaQuery()
  const [bubbleVisible, setBubbleVisible] = useState(false)
  if (isMobile) {
    return null
  }
  const handlerOnLightClick = () => {
    if (bubbleVisible) {
      return
    }
    setBubbleVisible(true)
    setTimeout(() => {
      setBubbleVisible(false)
    }, 3000)
  }
  return (
    <div className="f-bottom-section__side">
      <div
        className="v-bot__light flicker-in"
        role="button"
        onClick={handlerOnLightClick}
      ></div>
      {bubbleVisible && (
        <div className="v-bot__bubble fade-in">¡Exitos, tu puedes! </div>
      )}
      <StaticImage
        className="v-bot "
        src="../../../assets/images/v-bot/v-bot-top-players.webp"
        alt="V-bot dando un like"
        height={375}
        placeholder="blurred"
      />
    </div>
  )
}
